var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.onlineClass)?[_c('class-form',{attrs:{"onlineClass_prop":_vm.onlineClass,"edit_id":_vm.edit_id},on:{"update:onlineClass_prop":function($event){_vm.onlineClass=$event},"update:online-class_prop":function($event){_vm.onlineClass=$event}}})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }